import React from 'react';
import { useLocation } from 'react-router-dom';  // 必ずトップでインポート

export const StatusConfirmationPopup = ({
  showConfirmationPopup,
  confirmationPopupData,
  closeConfirmationPopup,
  confirmStatusChange
}) => {
  // ポップアップを出さないなら何もレンダーしない
  if (!showConfirmationPopup || !confirmationPopupData) {
    return null;
  }

  // ここからは通常ロジック
  if ( confirmationPopupData.isActive=== undefined){
    var isActive = confirmationPopupData.is_active;
  }
  else{
    var isActive = confirmationPopupData.isActive;
  }
  let actionText = isActive ? '停止' : '再開';

  return (
    <div className="confirmation-popup-overlay">
      <div className="confirmation-popup-container">
        <div className="confirmation-popup-content">
          <h2 className="confirmation-title">アカウント{actionText}確認</h2>
          
          <div className="confirmation-details">
            <div className="comment-header u-mt-medium">アカウント情報</div>
            <div className="confirmation-files">
              <div className="confirmation-file-item font-large">
                <div className="file-path">担当者名漢字: {confirmationPopupData.name}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">アカウント名（メールアドレス）: {confirmationPopupData.username}</div>
              </div>
              <div className="confirmation-file-item font-large">
                <div className="file-path">メールアドレス: {confirmationPopupData.accountname}</div>
              </div>
            </div>
          </div>
          
          <div className="action-buttons c-max-mini c-m-center">
            <button
              className="button button-secondary button-medium"
              onClick={closeConfirmationPopup}
            >
              キャンセル
            </button>
            <button
              className="btn btn-primary button-medium"
              onClick={confirmStatusChange}
            >
              {actionText}する
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
